var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-note"},[(_vm.$slots.title)?_c('p',{staticClass:"c-note__title"},[_c('Icon2',{attrs:{"variant":"attention","size":14}}),_vm._t("title")],2):_vm._e(),_c('div',{staticClass:"c-note__content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }